import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import AuthUserContainer from '../../containers/AuthUser';
import { post } from '../../modules/utility';

export const clockInRequiredMessage =
	'You must be clocked in before working on a driver report so your time is ' +
	'recorded. Please clock in below and you will be taken back to your report.';

//- Compliance: report work is on-duty time. Drivers must clock in before
//- they can open or submit a report, so the time lands on their shift.
const requireClockIn = (WrappedComponent) => {
	class RequireClockIn extends Component {
		constructor(props) {
			super(props);
			this.hasRequestedCheck = false;
			this.hasUnmounted = false;
			this.state = {
				isFetching: true,
				isCurrentlyClockedIn: false,
			};
		}

		componentDidMount() {
			this.checkClockInStatus();
		}

		//- authUser hydrates asynchronously after a hard refresh / deep link,
		//- so the check has to be able to start after mount too
		componentDidUpdate() {
			this.checkClockInStatus();
		}

		componentWillUnmount() {
			this.hasUnmounted = true;
		}

		checkClockInStatus = () => {
			const { authUser } = this.props;

			if (authUser?.role !== 'driver' || this.hasRequestedCheck) {
				return;
			}
			this.hasRequestedCheck = true;

			post({
				method: 'timeClockShift.user.getShiftAnalysis',
				params: {},
				callback: (err, r) => {
					if (this.hasUnmounted) {
						return;
					}

					//- If the status check itself fails, let the driver through —
					//- the backend still rejects report saves while clocked out.
					//- Only a definitive "not clocked in" answer redirects.
					const result = _.get(r, 'timeClockAnalysisResults.0', {});
					this.setState({
						isFetching: false,
						isCurrentlyClockedIn: err ? true : !!result.isCurrentlyClockedIn,
					});
				},
			});
		};

		render() {
			const { authUser, location } = this.props;
			const { isFetching, isCurrentlyClockedIn } = this.state;

			//- Wait for authUser to hydrate so a driver never sees the report
			//- screen before the clock-in check has run
			if (!authUser) {
				return <div>Checking your time clock status...</div>;
			}

			//- Only drivers are required to be on the clock
			if (authUser.role !== 'driver') {
				return <WrappedComponent {...this.props} />;
			}

			if (isFetching) {
				return <div>Checking your time clock status...</div>;
			}

			if (!isCurrentlyClockedIn) {
				return (
					<Redirect
						to={{
							pathname: '/clockInAndOut',
							state: {
								clockInRequired: true,
								returnTo: location ? `${location.pathname}${location.search || ''}` : undefined,
							},
						}}
					/>
				);
			}

			return <WrappedComponent {...this.props} />;
		}
	}

	RequireClockIn.propTypes = {
		authUser: PropTypes.object,
		location: PropTypes.object,
	};

	return AuthUserContainer(RequireClockIn);
};

export default requireClockIn;
